import template from './import_employees.html';
import tr from '../../lib/default-translator.js';

class AdminImportEmployeesViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.departments = ko.observableArray();	
		this.companies = ko.observableArray();
		this.company_id = ko.observable();
		this.department_id = ko.observable();

		// Observables for file input values
		this.batchFilePath = ko.observable('');
		this.modifyBatchFilePath = ko.observable('');

		// Subscriptions to update text inputs when file paths change
		this.batchFilePath.subscribe((newValue) => {
			let uploadInput = document.getElementById('upload_input');
			if (uploadInput)
				uploadInput.value = newValue.replace('C:\\fakepath\\', '');
		});

		this.modifyBatchFilePath.subscribe((newValue) => {
			let uploadModifyInput = document.getElementById('upload_modify_input');
			if (uploadModifyInput)
				uploadModifyInput.value = newValue.replace('C:\\fakepath\\', '');
		});

		this.checkProcessRunning = this.checkProcessRunning.bind(this);
	}

	close()
	{
		this.dialog.close(true);
	}

	disableImportButtons()
	{
		document.getElementById('import_modify_browse').disabled = true;
		document.getElementById('import_modify_button').disabled = true;
		document.getElementById('import_browse').disabled = true;
		document.getElementById('import_button').disabled = true;
		$("#import_notice").show();
	}

	enableImportButtons()
	{
		$("#import_notice").hide();
		document.getElementById('import_modify_browse').disabled = false;
		document.getElementById('import_modify_button').disabled = false;
		document.getElementById('import_button').disabled = false;
		document.getElementById('import_browse').disabled = false;
	}

	disableModifyButtons()
	{
		document.getElementById('import_modify_browse').disabled = true;
		document.getElementById('import_modify_button').disabled = true;
		document.getElementById('close_button_top').disabled = true;
		document.getElementById('close_button').disabled = true;
		document.getElementById('import_browse').disabled = true;
		document.getElementById('import_button').disabled = true;
		$('#import_modify_notice').show();
	}

	enableModifyButtons()
	{
		$('#import_modify_notice').hide();
		document.getElementById('import_modify_browse').disabled = false;
		document.getElementById('import_modify_button').disabled = false;
		document.getElementById('close_button_top').disabled = false;
		document.getElementById('import_button').disabled = false;
		document.getElementById('close_button').disabled = false;
		document.getElementById('import_browse').disabled = false;
	}

	async checkProcessRunning()
	{
		let res = await Grape.fetches.postJSON('/processes/is_process_active', {'process_name': 'import_employees_process'});

		if (res)
		{
			if (res.result == true)
			{
				this.disableImportButtons(); 
				window.setTimeout(this.checkProcessRunning, 5000); 
			}
			else
			{ 
				this.enableImportButtons(); 
				window.setTimeout(this.checkProcessRunning, 5000); 
			}
		}
	}

	show_employee_details_help()
	{
		Grape.dialog.open('EmployeeImportHelp', { employee_id: this.dialog.bindings.id });
	}
}

class AdminImportEmployeesPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminImportEmployeesViewModel(this);
	}

	async init()
	{
		this.viewModel.enableModifyButtons(); 
		this.viewModel.enableImportButtons(); 

		this.viewModel.checkProcessRunning();
		let cache_results = [];

		cache_results = await Promise.all([
			Grape.cache.get('CompanyLookup'),
			Grape.cache.get('DepartmentCompanyList')
		]);

		let companies = Object.assign([], cache_results[0]);
		companies.unshift({company: 'All', company_id: null});
		this.viewModel.companies(companies);

		let departments = Object.assign([], cache_results[1]);
		departments.unshift({department: 'All', department_id: null});
		this.viewModel.departments(departments);

		let batchFileInput = document.getElementById('batch_file');
		if (batchFileInput)
		{
			batchFileInput.addEventListener('change', (event) => {
				if (event.target.files.length > 0)
				{
					let filePath = event.target.value;
					this.viewModel.batchFilePath(filePath);
				}
			});
		}

		let modifyBatchFileInput = document.getElementById('modify_batch_file');
		if (modifyBatchFileInput) {
			modifyBatchFileInput.addEventListener('change', (event) => {
				if (event.target.files.length > 0)
				{
					let filePath = event.target.value;
					this.viewModel.modifyBatchFilePath(filePath);
				}
			});
		}
	}

	async importEXCELClick(v, e)
	{
		let button_disabled = document.getElementById('import_button');
		if (button_disabled.disabled)
			return;

		if ($('#upload_input').val() == '')
		{
			Grape.alerts.alert({ type: 'error', message: tr('Please select a file'), title: tr('Error') });
			return;
		}

		let formData = new FormData($('#batchuploadform')[0]);
		let file = document.getElementById('batch_file').files[0];

		if (file)
		{
			if (file.size > 20000000)
			{
				Grape.alerts.alert({ type: 'error', message: tr('File size exceeds the maximum limit of 20MB'), title: tr('Error') });
				formData.append('abort_upload', 'true');
				return;
			}
		}

		formData.append('filename', $('#upload_input').val());

		try {
			this.viewModel.disableImportButtons();

			let response = await fetch('/admin/import_employee_excel', {
				method: 'POST',
				body: formData
			});

			let res = await response.json();

			if (res.status === 'OK')
			{
				await Grape.alerts.alert({ type: 'success', message: tr('Employees will be imported in the background. You will receive an email when the import process finishes.'), title: tr('Process started') });
				this.close();
			}
			else if (res.status === 'ERROR')
				Grape.alerts.alert({ type: 'error', message: res.message, title: 'Error' });
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });

		} catch (error) {
			Grape.alerts.alert({ type: 'error', message: tr('An error occurred while processing your request.'), title: tr('Error') });
		}
	}

	async importmodifyEXCELClick(v, e)
	{
		let button_disabled = document.getElementById('import_modify_button');
		if (button_disabled.disabled)
			return;

		if ($('#upload_modify_input').val() == '')
		{
			Grape.alerts.alert({
				type: 'error',
				message: tr('Please select a file'),
				title: tr('Error', 'Error')
			});
			return;
		}

		let formData = new FormData($('#modifybatchuploadform')[0]);
		let file = document.getElementById('modify_batch_file').files[0];

		if (file)
		{
			if (file.size > 20000000)
			{
				Grape.alerts.alert({ type: 'error', message: tr('File size exceeds the maximum limit of 20MB'), title: tr('Error') });
				formData.append('abort_upload', 'true');
				return;
			}
		}

		formData.append('filename', $('#upload_modify_input').val());

		try {
			this.viewModel.disableModifyButtons();
		
			let response = await fetch('/admin/modify_employee_excel', {
				method: 'POST',
				body: formData
			});

			if (!response.ok)
				throw new Error('Network response was not ok');

			let res = await response.json();

			// Check if res is an array (successful case) or an object (error case)
			if (Array.isArray(res))
			{
				let all_statuses = res.every(result => result.status === 'OK');

				if (all_statuses)
				{
					await Grape.alerts.alert({ type: 'success', message: tr('Successfully modified employees.'), title: tr('Success') });
					this.close();
				}
				else
				{
					// Some entries have errors
					let error_messages = res
						.filter(result => result.status === 'ERROR')
						.map(result => result.message)
						.join(' , ');
		
					Grape.alerts.alert({ type: 'error', message: tr(error_messages), title: tr('Error') });
				}
			}
			else if (res.status === 'ERROR')
				Grape.alerts.alert({ type: 'error', message: tr(res.message), title: tr('Error') });

		}
		catch (error)
		{
			console.error('Caught error:', error);
			Grape.alerts.alert({ type: 'error', message: tr('An error occurred while processing your request.'), title: tr('Error') });
		}
	}

	importModifyFormat(v,e)
	{
		window.location.href = '/admin/download_employee_modify_format/' + this.viewModel.department_id() + '/' + this.viewModel.company_id() ;
	}

	importFormat(v,e)
	{
		window.location.href = '/admin/download_employee_import_format';
	}
}

export default {
	name: 'AdminImportEmployees',
	dialog_class: AdminImportEmployeesPage,
	template: template,
	template_filename: 'translation/dialogs/import_employees',
	provider: 'ps'
}
